import React, { useState } from "react"
import { Col, Row } from "reactstrap"
import { useHistory, useParams } from "react-router-dom"
import toast from "react-hot-toast"
import { DragDropContext, Droppable } from "react-beautiful-dnd"

import settingsIcon from "../../../assets/images/icons/settings-icon.svg"

import ActiveInactiveSwitch from "../CommonUI/ActiveInactiveSwitch/ActiveInactiveSwitch"
import { DataTable } from "../../../components/DataTable"
import { useLocalPaginatedRequest } from "../../../hooks/useLocalPaginatedRequest"
import { Pagination } from "../../../components/Pagination"
import {
   GetTrailerCustomizationCategoryDetails,
   GetTrailerCustomizationsListing,
   UpdateTrailerCustomizationCategory,
   GetTrailerBaseFeaturesCategoriesListing,
   CreateCustomizationCategory,
   DeleteCustomizationCategory,
   UpdateTrailerCustomizationSequence,
} from "../../../api/api.service"
import { APP_ROUTES, getRoute } from "../../../helpers/routeHelpers"
import { SearchBox } from "../../../components/SearchBox"
import { AutoComplete } from "../../../components/AutoComplete"
import { EquipmentCategoriesStatus, TrailerStatus } from "../../../constants"
import {
   convertToSelectOptions,
   replaceSlashes,
} from "../../../utils/commonUtils"
import { convertDateTime, dateTimeFormat } from "utils/dateFormatUtils"
import ManageSettingsCategory from "../CommonUI/ManageSettingsCategory/ManageSettingsCategory"
import useAsyncSelect from "hooks/useAsyncSelect"
import DeleteModal from "../CommonUI/Modal/DeleteModal"
import autoCompleteStyles from "components/AutoComplete/autoCompleteStyles"
import TruncatedTextWithTooltip from "components/CustomTooltip/CustomTooltip"

const COLUMNS = {
   CATEGORY: "Category",
   BASE_FEATURE: "Base Feature",
   DATE_EDITED: "Date edited",
   NO_OF_ITEMS: "No. of items",
   STATUS: "Status",
   ACTIONS: "Actions",
}

const DATA_KEY = "data"
const TOTAL_KEY = "total"
const TITLES = {
   MODAL_ADD_TITLE: "Add category",
   MODAL_UPDATE_TITLE: "Update category",
   MODAL_DETAILS_TITLE: "Category details",
   ADD_BTN_TEXT: "Save",
   UPDATE_BTN_TEXT: "Update",
   DETAILS_BTN_TEXT: "Done",
}

const Customization = ({}) => {
   const history = useHistory()
   const { trailerId } = useParams()
   const [statusFilters, setStatusFilters] = useState(null)
   const [baseFeatureFilter, setBaseFeatureFilter] = useState(null)
   const [selection, setSelection] = useState({})
   const [openDelModal, setOpenDelModal] = useState(false)

   const {
      setSelectedOption: setSelectedBaseFeature,
      selectEntity: baseFeaturesOptions,
      setSelectEntity: setBaseFeaturesOptions,
      handleSearchOnOptions: handleSearchBaseFeature,
      selectedOption: selectedBaseFeature,
      handleSelectAOption: handleSelectABaseFeatureOption,
   } = useAsyncSelect({
      apiFunc: GetTrailerBaseFeaturesCategoriesListing,
      labelKey: "name",
      valueKey: "id",
      restrictExecutionOnRender: false,
      params: {
         trailerId: trailerId,
      },
      onOptionSelect: option => {
         option?.id &&
            setBaseFeatureFilter({
               configuratorBaseFeaturesId: option.id,
            })
      },
   })

   const {
      data,
      isFetching,
      page,
      searchText,
      pageSize,
      total,
      handleSearchChange,
      request,
      handlePageClick,
      onChangePageSize,
      setTableDataChangeLoading,
      tableDataChangeLoading,
      setData,
   } = useLocalPaginatedRequest({
      requestFn: GetTrailerCustomizationsListing,
      customParams: {
         limit: -1,
         page: 1,
         configuratorTrailerId: trailerId,
         ...(statusFilters?.value && { status: statusFilters?.value }),
         ...(baseFeatureFilter?.configuratorBaseFeaturesId &&
            selectedBaseFeature?.value && {
               configuratorBaseFeaturesId:
                  baseFeatureFilter?.configuratorBaseFeaturesId,
            }),
         column: "sequenceNo",
      },
      deps: [statusFilters, baseFeatureFilter, selectedBaseFeature],
      dataKey: DATA_KEY,
      totalKey: TOTAL_KEY,
   })

   const [eventsType, setEventsType] = useState({
      isManage: null,
      isUpdate: null,
      isDetails: null,
   })

   const handleInitManage = obj => {
      setEventsType(prev => ({ ...prev, isManage: true }))
      setSelection(obj)
   }

   const handleNavigateToCategoryItems = obj => {
      setSelection(obj)

      return history.push(
         getRoute(
            APP_ROUTES.CONFIGURATOR_TRAILER_SETTINGS_CUSTOMIZATION_ITEMS,
            {
               trailerId: trailerId,
               categoryId: obj.id,
               categoryName: replaceSlashes(obj.name),
            }
         )
      )
   }
   const handleSelectStatusOption = option => {
      setStatusFilters(option)
   }

   const handleStatusChange = async (currStatus, id) => {
      let status =
         currStatus === EquipmentCategoriesStatus.Active
            ? EquipmentCategoriesStatus.Inactive
            : EquipmentCategoriesStatus.Active
      let dataClone = [...data]
      dataClone.map(el => {
         if (el?.id == id) el.status = status
      })
      setData(dataClone)
      let payload = {
         status: status,
      }
      try {
         setTableDataChangeLoading(true)
         let res = await UpdateTrailerCustomizationCategory(id, payload)
         toast.success("Category status has been updated !")
      } catch (err) {
         toast.error(err.message)
         let dataClone = [...data]
         dataClone.map(el => {
            if (el?.id == id) el.status = currStatus
         })
         setData(dataClone)
      } finally {
         setTableDataChangeLoading(false)
      }
   }

   const handleInitDelete = obj => {
      setSelection(obj)
      setOpenDelModal(prev => !prev)
   }

   const handleDragEnd = async result => {
      if (!result.destination) return

      const items = Array.from(data)
      const [reorderedItem] = items.splice(result.source.index, 1)
      items.splice(result.destination.index, 0, reorderedItem)

      setData(items)

      let payload = {
         trailerId: trailerId,
         sequenceItems: items.map((trailerObj, ind) => ({
            id: Number(trailerObj.id),
            sequenceNo: ind,
         })),
      }

      try {
         await UpdateTrailerCustomizationSequence(payload)
         toast.success("Sequence updated successfully!")
      } catch (err) {
         toast.error("Failed to update sequence")
      }
   }

   return (
      <>
         <div className="mb-2">
            <div className="d-flex align-items-center justify-content-between admin-inventory-request-form-fields ">
               <div className="d-flex justify-content-start align-items-center admin-inventory-request-autocomplete">
                  <div className="min-250-w margin-right-handle me-2">
                     <AutoComplete
                        value={statusFilters}
                        isClearable
                        onChange={val => handleSelectStatusOption(val)}
                        isSearchable={false}
                        placeholder="Select status"
                        customStyles={autoCompleteStyles.STYLE_SIX}
                        classNamePrefix="status-header-search-admin"
                        options={convertToSelectOptions(
                           EquipmentCategoriesStatus
                        )}
                     />
                  </div>
                  <div className="min-250-w margin-top-handle"></div>
               </div>
               <div className="ad-search-container location-search-box  ">
                  <SearchBox
                     inputClasses="vendor-search-input input-search "
                     labelClass="d-none"
                     placeholder="Search"
                     searchIcon={true}
                     searchIconClass="vendor-table-search-icon"
                     conClass="vendor-table-search-inner-class admin-inventory-request-search-box-responsive"
                     searchText={searchText}
                     onChange={handleSearchChange}
                  />
               </div>
            </div>
         </div>

         <Row>
            <Col md={12}>
               <DragDropContext onDragEnd={handleDragEnd}>
                  <Droppable droppableId="droppable">
                     {provided => (
                        <div
                           {...provided.droppableProps}
                           ref={provided.innerRef}
                        >
                           <DataTable
                              isDraggable={true}
                              droppablePlaceholder={provided.placeholder}
                              data={data}
                              tableClasses="customization-table"
                              loading={isFetching}
                              config={[
                                 {
                                    title: COLUMNS.BASE_FEATURE,
                                    className: "",
                                    render: data => {
                                       return (
                                          <TruncatedTextWithTooltip
                                             text={data.name}
                                          />
                                       )
                                    },
                                 },
                                 {
                                    title: COLUMNS.DATE_EDITED,
                                    className: "",
                                    render: data => {
                                       return convertDateTime({
                                          date: data.updatedAt,
                                          customFormat:
                                             dateTimeFormat.casitaCustomDateFormat,
                                          dateOnly: true,
                                       })
                                    },
                                 },

                                 {
                                    title: COLUMNS.NO_OF_ITEMS,
                                    className: "",
                                    render: data => data?.totalItems,
                                 },

                                 {
                                    title: COLUMNS.STATUS,
                                    className: "",
                                    render: data => (
                                       <ActiveInactiveSwitch
                                          isDisable={tableDataChangeLoading}
                                          id={data.id}
                                          name={`${data.id}`}
                                          onChange={e =>
                                             handleStatusChange(
                                                data?.status,
                                                data?.id
                                             )
                                          }
                                          isChecked={
                                             data?.status ==
                                             EquipmentCategoriesStatus.Active
                                          }
                                       />
                                    ),
                                 },

                                 {
                                    title: COLUMNS.ACTIONS,

                                    render: data => (
                                       <div className="d-flex gap-2 pointer">
                                          <img
                                             src={settingsIcon}
                                             onClick={() =>
                                                handleNavigateToCategoryItems(
                                                   data
                                                )
                                             }
                                          />
                                       </div>
                                    ),
                                 },
                              ]}
                           />
                        </div>
                     )}
                  </Droppable>
               </DragDropContext>
            </Col>
            <Pagination
               currentPage={page}
               totalData={total}
               onPageClick={handlePageClick}
               rowLimit={pageSize}
               onChangePageSize={onChangePageSize}
            />
         </Row>

         <ManageSettingsCategory
            TITLES={TITLES}
            subTitle="Personalization"
            addApiFunc={CreateCustomizationCategory}
            entityApiKey="name"
            entityName="Personalization Category"
            fetchApiFunc={GetTrailerCustomizationCategoryDetails}
            statusConstObj={TrailerStatus}
            title="Category"
            textFieldPlaceholder="Enter name"
            updateApiFun={UpdateTrailerCustomizationCategory}
            textFieldLabel="Name"
            isOpen={eventsType.isManage}
            id={selection?.id}
            onSuccess={request}
            payloadData={{
               configuratorTrailerId: Number(trailerId),
            }}
            onToggleModal={() => {
               setSelection({})
               setEventsType(prev => ({
                  ...prev,
                  isManage: false,
               }))
            }}
            hasBaseFeature
         />
         <DeleteModal
            isOpen={openDelModal}
            toggleFunction={setOpenDelModal}
            id={selection.id}
            apiFunction={DeleteCustomizationCategory}
            title={"Personalization Category"}
            requestFunction={request}
         />
      </>
   )
}

export default Customization
